function ngConfirmClickDirective() {
    'ngInject';

    return {
        link(scope, element, attr) {
            const msg = attr.ngConfirmClick || 'Are you sure?';
            const clickAction = attr.ngConfirmedClick;
            element.bind('click', (event) => {
                if (window.confirm(msg)) {
                    return scope.$eval(clickAction);
                }
            });
        }
    };
}

angular
    .module('BB')
    .directive('ngConfirmClick', ngConfirmClickDirective);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/ng-confirm-click/ng_confirm_click.directive.js